/**
 * Parse a string to an enum value if it exists.
 * @param enumObj The enum object.
 * @param value The value to parse.
 * @returns The parsed enum value or undefined if it does not exist.
 */
export function parseEnum<T>(
	enumObj: { [s: string]: T },
	value: string,
): T | undefined {
	// Check if the value directly exists in the enum values
	if (Object.values(enumObj).includes(value as unknown as T)) {
		return value as unknown as T;
	}
	return undefined;
}
